import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonLoaderComponent } from './components/loader/loader.component';
import { CommonLoaderContainerComponent } from './components/loader-container/loader-container.component';

@NgModule({
	imports: [
		CommonModule,
	],
	exports: [
		CommonLoaderComponent,
		CommonLoaderContainerComponent,
	],
	declarations: [
		CommonLoaderComponent,
		CommonLoaderContainerComponent,
	],
	entryComponents: [
		CommonLoaderComponent,
		CommonLoaderContainerComponent,
	],
})
export class CommonLoaderModule {}
